import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Typography, message } from "antd";
import axios from "axios";

const { Title } = Typography;

const VehicleTypesForm = ({ formData, setFormData, closeModal, setSubmitted }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
    }
  }, [formData, form]);

  const onFinish = async (values) => {
    const requestData = {
      ...values,
    };

    try {
      let response;
      if (formData?.id) {
        // Update vehicle type
        response = await axios.put(
          `http://93.127.203.113:5005/vehicleTypes/${formData.id}`,
          requestData
        );
      } else {
        // Add new vehicle type
        response = await axios.post("http://93.127.203.113:5005/vehicleTypes", requestData);
      }

      if (response?.data) {
        message.success("Vehicle type saved successfully");
      }

      setFormData({});
      closeModal();
      setSubmitted(true); // Trigger data refresh after submission
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save vehicle type");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData?.id ? "Edit Vehicle Type" : "Add Vehicle Type"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Type Name"
              name="typeName"
              rules={[{ required: true, message: "Please enter the type name" }]}
            >
              <Input placeholder="Enter type name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Price Per Day"
              name="pricePerKM"
              rules={[{ required: true, message: "Please enter the price per day" }]}
            >
              <Input placeholder="Enter price per day" type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Max Price Per Day"
              name="surgePricePerKM"
              rules={[{ required: true, message: "Please enter the max price per day" }]}
            >
              <Input placeholder="Enter max price per day" type="number" />
            </Form.Item>
          </Col>
        </Row>

        <div style={{ textAlign: "right" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "#0c8c49",
              borderColor: "#0c8c49",
              marginRight: "10px",
            }}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => form.resetFields()}
            style={{
              backgroundColor: "#f5f5f5",
              borderColor: "#d9d9d9",
            }}
          >
            Reset
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default VehicleTypesForm;
